import { render, staticRenderFns } from "./lecture-list-item-dispatcher.vue?vue&type=template&id=bebadf50"
import script from "./lecture-list-item-dispatcher.vue?vue&type=script&lang=js"
export * from "./lecture-list-item-dispatcher.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports